import React from "react";
import { Link } from "react-router-dom";
import Button from "./Button";
import "./Jobcard.css";
import { BiLocationPlus } from "react-icons/bi";

function JobCard({ data }) {
  return (
    <div className="p-4 my-4 shadow-xl ring-2 w-full ring-gray-600 rounded-md  ">
      <div className="flex flex-row justify-between mb-4">
        <div>
          <p className="text-xl text-gray-800 font-semibold">{data.jobTitle}</p>
          <p className="text-base text-gray-600 font-semibold">
            {data.company}
          </p>
        </div>
        <img
          className="w-12 h-12 object-contain"
          src={data.companyLogo}
          alt=""
        />
      </div>
      <p className="flex flex-row items-center text-gray-600 font-semibold gap-2 mb-4">
        <BiLocationPlus /> {data.location}
      </p>
      <div className="flex flex-row gap-6 justify-between mb-4">
        <div>
          <p className="text-base text-gray-500">Skills Required</p>
          <p className="text-base text-gray-800 font-semibold">{data.skills}</p>
        </div>
        <div>
          <p className="text-base text-gray-500">Experience Required</p>
          <p className="text-base text-gray-800 font-semibold">{data.exp}</p>
        </div>
        <div>
          <p className="text-base text-gray-500">Stipend/Package</p>
          <p className="text-base text-gray-800 font-semibold">{data.salary}</p>
        </div>
      </div>
      <p className="flex flex-row gap-2 mb-4 text-base text-gray-500">
        Apply By:{" "}
        <p className="text-base text-gray-800 font-semibold">{data.endDate}</p>
      </p>
      <div className="flex flex-col mb-4">
        <h2 className="text-base text-gray-800 font-semibold">Posted By:</h2>
        <h2 className="text-base text-gray-500">{data.name}</h2>
        <p className="text-base text-gray-500">{data.batch}</p>
        <p className="text-base text-gray-500">{data.email}</p>
      </div>

      <div className="btn">
        <a href={data.link} target="_blank">
        <Button classN="text-white">
            Apply
        </Button>
          </a>
      </div>
    </div>
  );
}

export default JobCard;
